const initMessage = ''
//Redux notifikaation hallinnalle
const notificationReducer = (state = initMessage, action) => {
  switch (action.type) {
  case 'SETMESSAGE':
    return action.message
  default:
    return state
  }
}

export const notify = (message) => {
  return {
    type: 'SETMESSAGE',
    message
  }
}

export const setNotification = (message) => {
  return async (dispatch) => {
    console.log(message)
    dispatch(notify(message))
  }
}

export default notificationReducer